/** The `@…` token the caret currently sits in. */
export interface ActiveMention {
  /** Index of the `@`. */
  start: number;
  /** Exclusive end — the caret position. */
  end: number;
  /** Entity prefix of `@entity:term`; `null` for a bare `@term`. */
  entity: string | null;
  term: string;
}

const WHITESPACE = /\s/;

/**
 * Pure: no DOM, no signals. A mention only starts at the beginning of the text
 * or after whitespace, so an e-mail address in the draft is never treated as one.
 */
export function findActiveMention(text: string, caret: number): ActiveMention | null {
  if (caret < 0 || caret > text.length) return null;

  let start = caret - 1;
  while (start >= 0 && !WHITESPACE.test(text[start])) {
    if (text[start] === '@') break;
    start--;
  }
  if (start < 0 || text[start] !== '@') return null;
  if (start > 0 && !WHITESPACE.test(text[start - 1])) return null;

  const token = text.slice(start + 1, caret);
  if (WHITESPACE.test(token)) return null;

  const colon = token.indexOf(':');
  if (colon === -1) return { start, end: caret, entity: null, term: token };
  return {
    start,
    end: caret,
    entity: token.slice(0, colon),
    term: token.slice(colon + 1),
  };
}

export function replaceRange(
  text: string,
  start: number,
  end: number,
  replacement: string
): string {
  return text.slice(0, start) + replacement + text.slice(end);
}
